import { ref, onMounted, onUnmounted } from 'vue';

export function useScreenSize() {
    const screenWidth     = ref(window.innerWidth <= 768);
    const show_menu       = ref(false);
    const show_menu_close = ref(false);
    const is_collapse     = ref(false);

    const check = () => {
        const w = window.innerWidth;

        screenWidth.value = w <= 768;

        if (w >= 768) {
            is_collapse.value = false;
            show_menu.value   = true;
        } else {
            is_collapse.value = true;
            show_menu.value   = false;
        }

        show_menu_close.value = w >= 1024;
    };

    onMounted(() => {
        check();
        window.addEventListener('resize', check);
    });

    onUnmounted(() => {
        window.removeEventListener('resize', check);
    });

    return { screenWidth, show_menu, show_menu_close, is_collapse };
}